[
  {
    "gtin": "01000001",
    "name": "Apple Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998253/products/pim/8700216678445-788450549/ariel-colorwaschmittel-pods",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.21,
      "x1": 1.0,
      "y1": 0.79,
      "aspect": 1.7241
    },
    "placements": [
      {
        "shelfId": "LFYN",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4eb9"
      },
      {
        "shelfId": "QPQH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4e91"
      },
      {
        "shelfId": "CQGZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4e9a"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000002",
    "name": "Banana Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.59,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744984838/products/pim/4066447600094-924726970/balea-men-antitranspirant-deospray-invisible-dry",
    "imageOutline": {
      "x0": 0.365,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.27
    },
    "placements": [
      {
        "shelfId": "LFYN",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ea4"
      },
      {
        "shelfId": "VA2W",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec1"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000003",
    "name": "Carrot Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744820877/products/pim/4014531690704-3894081/soapland-aufbewahrungskorb-klein-schwarz",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.025,
      "x1": 1.0,
      "y1": 0.97,
      "aspect": 1.0582
    },
    "placements": [
      {
        "shelfId": "W8EL",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ee4"
      },
      {
        "shelfId": "R7AG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec4"
      },
      {
        "shelfId": "I6WJ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f35"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000004",
    "name": "Dairy Milk",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746174365/products/pim/3830079880855-842194728/byrokko-braeunungsbeschleuniger-creme-shine-brown-original",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.13,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3423
    },
    "placements": [
      {
        "shelfId": "UCIU",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4fe0"
      },
      {
        "shelfId": "7YRG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff500e"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000005",
    "name": "Egg Noodles",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744808414/products/pim/4058172737381-3518267/dmbio-brotaufstrich-vegane-pastete-shiitake-champignon",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.115,
      "x1": 1.0,
      "y1": 0.885,
      "aspect": 1.2987
    },
    "placements": [
      {
        "shelfId": "R7AG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec5"
      },
      {
        "shelfId": "I6WJ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f70"
      },
      {
        "shelfId": "7GAY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff5066"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000006",
    "name": "Fig Bars",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998713/products/pim/4006000131467-926683978/hidrofugal-antitranspirant-deospray-men-frisch-und-stark",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "61OA",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5094"
      },
      {
        "shelfId": "VZF1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff50c2"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000007",
    "name": "Grape Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757645085/products/pim/3574661818207-1232467348/penaten-baby-pflegecreme-gesicht-und-koerper-intensiv",
    "imageOutline": {
      "x0": 0.01,
      "y0": 0.0,
      "x1": 0.99,
      "y1": 1.0,
      "aspect": 0.98
    },
    "placements": [
      {
        "shelfId": "808E",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff508e"
      },
      {
        "shelfId": "NTS7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff511d"
      },
      {
        "shelfId": "WJBB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5137"
      }
    ],
    "inventory": {
      "quantity": 17
    }
  },
  {
    "gtin": "01000008",
    "name": "Honey Oats",
    "brandName": "BreakfastBest",
    "baseCategory": "Cereals & Breakfast",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980954/products/pim/4066447709889-1906462775/babylove-baby-koerperlotion-ultra-sensitive",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.68,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "FXB3",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5193"
      },
      {
        "shelfId": "G5T5",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff51db"
      }
    ],
    "inventory": {
      "quantity": 23
    }
  },
  {
    "gtin": "01000009",
    "name": "Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746174365/products/pim/3830079880855-842194728/byrokko-braeunungsbeschleuniger-creme-shine-brown-original",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.13,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3423
    },
    "placements": [
      {
        "shelfId": "D76M",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff522f"
      },
      {
        "shelfId": "XR45",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5262"
      },
      {
        "shelfId": "WFOG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5291"
      },
      {
        "shelfId": "3T21",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5349"
      }
    ],
    "inventory": {
      "quantity": 5
    }
  },
  {
    "gtin": "01000010",
    "name": "Jelly Beans",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744973161/products/pim/4066447429121-1900720101/balea-augen-make-up-entferner-oelfrei",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "W4Q3",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff53b9"
      },
      {
        "shelfId": "LTUI",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff53ef"
      }
    ],
    "inventory": {
      "quantity": 31
    }
  },
  {
    "gtin": "01000011",
    "name": "Kiwi Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1754533961/products/pim/4066447374544-1364358599/balea-abschminktuecher-3in1-erfrischend",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.125,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3333
    },
    "placements": [
      {
        "shelfId": "QYLL",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f70"
      }
    ],
    "inventory": {
      "quantity": 12
    }
  },
  {
    "gtin": "01000012",
    "name": "Lemonade",
    "brandName": "CitrusFresh",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744982557/products/pim/4251099705932-546723175/alete-bewusst-abendbrei-getreide-banane-kakao-ab-dem-8-monat",
    "imageOutline": {
      "x0": 0.205,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.59
    },
    "placements": [
      {
        "shelfId": "J6PV",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5738"
      }
    ],
    "inventory": {
      "quantity": 27
    }
  },
  {
    "gtin": "01000013",
    "name": "Mango Lassi",
    "brandName": "Yogurto",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744821202/products/pim/4023103238992-3935353/vileda-allzwecktuecher-mikrofaser-colors-multipack",
    "imageOutline": {
      "x0": 0.2,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.595
    },
    "placements": [
      {
        "shelfId": "ZVI3",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff5755"
      }
    ],
    "inventory": {
      "quantity": 8
    }
  },
  {
    "gtin": "01000014",
    "name": "Nutty Bars",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744982557/products/pim/4251099705932-546723175/alete-bewusst-abendbrei-getreide-banane-kakao-ab-dem-8-monat",
    "imageOutline": {
      "x0": 0.205,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.59
    },
    "placements": [
      {
        "shelfId": "OP85",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff5790"
      }
    ],
    "inventory": {
      "quantity": 21
    }
  },
  {
    "gtin": "01000015",
    "name": "Olive Oil",
    "brandName": "PurePress",
    "baseCategory": "Oils & Vinegars",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744820875/products/pim/4014531690803-3894091/soapland-ablageschale-aus-keramik-und-bambus-schwarz",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.17,
      "x1": 1.0,
      "y1": 0.83,
      "aspect": 1.5152
    },
    "placements": [
      {
        "shelfId": "F82V",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff580b"
      }
    ],
    "inventory": {
      "quantity": 3
    }
  },
  {
    "gtin": "01000016",
    "name": "Peach Tea",
    "brandName": "TeaTime",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745005715/products/pim/8700216670456-299438734/pampers-baby-pants-baby-dry-gr-8-extra-large-17-kg",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.0,
      "x1": 1.0,
      "y1": 1.0,
      "aspect": 1.0
    },
    "placements": [
      {
        "shelfId": "RF6Y",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff5845"
      }
    ],
    "inventory": {
      "quantity": 29
    }
  },
  {
    "gtin": "01000017",
    "name": "Quinoa Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745887586/products/pim/4008871200372-1196407497/toppits-backpapier-boegen-mit-antihaft-struktur",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.425,
      "x1": 1.0,
      "y1": 0.575,
      "aspect": 6.6667
    },
    "placements": [
      {
        "shelfId": "JKT2",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff582e"
      }
    ],
    "inventory": {
      "quantity": 14
    }
  },
  {
    "gtin": "01000018",
    "name": "Raspberry Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744995258/products/pim/3600524142261-1731351600/l-oreal-paris-elvital-conditioner-hydra-hyaluronic-pure",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.395
    },
    "placements": [
      {
        "shelfId": "6QPN",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff614a"
      }
    ],
    "inventory": {
      "quantity": 6
    }
  },
  {
    "gtin": "01000019",
    "name": "Strawberry Jam",
    "brandName": "BerryBest",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1754533961/products/pim/4066447374544-1364358599/balea-abschminktuecher-3in1-erfrischend",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.125,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3333
    },
    "placements": [
      {
        "shelfId": "C7L5",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff585d"
      }
    ],
    "inventory": {
      "quantity": 10
    }
  },
  {
    "gtin": "01000020",
    "name": "Tomato Soup",
    "brandName": "SoupMaster",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744968964/products/pim/4051424570019-1495879709/dr-scheller-anti-falten-nachtcreme-argan",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.105,
      "x1": 1.0,
      "y1": 0.89,
      "aspect": 1.2739
    },
    "placements": [
      {
        "shelfId": "97C0",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63a1"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000021",
    "name": "Udon Noodles",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746791166/products/pim/4066447713480-1543093769/balea-anti-falten-gesichtscreme-q10-lsf-15",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.125,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3333
    },
    "placements": [
      {
        "shelfId": "XR45",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff5286"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000022",
    "name": "Vanilla Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002790/products/pim/42449980-62095101/hidrofugal-antitranspirant-deo-roll-on-classic",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "OP85",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff57aa"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000023",
    "name": "Walnut Brownies",
    "brandName": "NuttyBakes",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744986681/products/pim/4066447725230-1988101657/mivolis-bonbon-salbeibonbons-zuckerfrei",
    "imageOutline": {
      "x0": 0.12,
      "y0": 0.0,
      "x1": 0.885,
      "y1": 1.0,
      "aspect": 0.765
    },
    "placements": [
      {
        "shelfId": "TSZK",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ba2"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000024",
    "name": "Xylitol Gum",
    "brandName": "FreshChew",
    "baseCategory": "Gum & Mints",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757727252/products/pim/4001638523127-1516675825/weleda-baby-baby-waschlotion-und-shampoo-calendula",
    "imageOutline": {
      "x0": 0.29,
      "y0": 0.0,
      "x1": 0.71,
      "y1": 1.0,
      "aspect": 0.42
    },
    "placements": [
      {
        "shelfId": "RJQ3",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5945"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000025",
    "name": "Yogurt Drink",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757644508/products/pim/3574661749532-720134251/neutrogena-anti-pickel-gesichtsgel-niacinamide-panthenol",
    "imageOutline": {
      "x0": 0.09,
      "y0": 0.0,
      "x1": 0.91,
      "y1": 1.0,
      "aspect": 0.82
    },
    "placements": [
      {
        "shelfId": "ZK8K",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5fe4"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000026",
    "name": "Zucchini Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744997586/products/pim/7613038463070-1938439522/nestle-beba-anfangsmilch-1-von-geburt-an",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.845,
      "y1": 1.0,
      "aspect": 0.695
    },
    "placements": [
      {
        "shelfId": "NTS7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5119"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000027",
    "name": "Almond Milk",
    "brandName": "NutriMilk",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744752005/products/pim/4009077020559-2445577/kinder-em-eukal-bonbon-wildkirsche-fuer-kinder-zuckerfrei",
    "imageOutline": {
      "x0": 0.205,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.59
    },
    "placements": [
      {
        "shelfId": "G5T5",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff51db"
      }
    ],
    "inventory": {
      "quantity": 15
    }
  },
  {
    "gtin": "01000028",
    "name": "Berry Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744981750/products/pim/59092575-930781851/dove-men-care-anti-transpirant-roll-on-advanced-clean-comfort",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.69,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "NME1",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6317"
      }
    ],
    "inventory": {
      "quantity": 10
    }
  },
  {
    "gtin": "01000029",
    "name": "Coconut Water",
    "brandName": "TropicalTaste",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748996898/products/pim/4895248007746-1506741479/rascals-baby-pants-premium-gr-5-13-18-kg",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.835,
      "y1": 1.0,
      "aspect": 0.67
    },
    "placements": [
      {
        "shelfId": "WFOG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff529d"
      }
    ],
    "inventory": {
      "quantity": 10
    }
  },
  {
    "gtin": "01000030",
    "name": "Date Bars",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980699/products/pim/4042441019292-1175424646/balea-blasenpflaster-zehen",
    "imageOutline": {
      "x0": 0.185,
      "y0": 0.0,
      "x1": 0.815,
      "y1": 1.0,
      "aspect": 0.63
    },
    "placements": [
      {
        "shelfId": "DYU9",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5523"
      }
    ],
    "inventory": {
      "quantity": 85
    }
  },
  {
    "gtin": "01000031",
    "name": "Earl Grey Tea",
    "brandName": "TeaTime",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998337/products/pim/42449782-810034511/nivea-antitranspirant-deostick-derma-dry-control-maximum",
    "imageOutline": {
      "x0": 0.28,
      "y0": 0.045,
      "x1": 0.755,
      "y1": 1.0,
      "aspect": 0.4974
    },
    "placements": [
      {
        "shelfId": "AC64",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5a6d"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000032",
    "name": "Fruit Punch",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744999810/products/pim/4015200035116-1144142571/persil-colorwaschmittel-gel-excellence",
    "imageOutline": {
      "x0": 0.265,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.47
    },
    "placements": [
      {
        "shelfId": "RF6Y",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff581b"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000033",
    "name": "Ginger Ale",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745308316/products/pim/8700216702447-76799435/ariel-colorwaschmittel-pulver",
    "imageOutline": {
      "x0": 0.05,
      "y0": 0.0,
      "x1": 0.95,
      "y1": 1.0,
      "aspect": 0.9
    },
    "placements": [
      {
        "shelfId": "V0FB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5cc1"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000034",
    "name": "Hazelnut Spread",
    "brandName": "NuttyBakes",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744816732/products/pim/4066447212129-3748420/mivolis-arzneitee-brennnessel-tee-12-beutel",
    "imageOutline": {
      "x0": 0.005,
      "y0": 0.0,
      "x1": 0.995,
      "y1": 1.0,
      "aspect": 0.99
    },
    "placements": [
      {
        "shelfId": "2B3W",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff6003"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000035",
    "name": "Italian Pasta",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747875984/products/pim/42449942-655523720/hidrofugal-antitranspirant-deo-roll-on-men-frisch-und-stark",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "GKVE",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f2b"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000036",
    "name": "Jackfruit Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1755907677/products/pim/4062300321335-1598776057/hipp-abendbrei-gute-nacht-dinkelgriess-ab-dem-6-monat",
    "imageOutline": {
      "x0": 0.175,
      "y0": 0.0,
      "x1": 0.82,
      "y1": 1.0,
      "aspect": 0.645
    },
    "placements": [
      {
        "shelfId": "19TJ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6452"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000037",
    "name": "Kale Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744766526/products/pim/4058172934384-2917274/reell-e-ansatzspray-blond-bis-mittelblond",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "N2I9",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5e1f"
      }
    ],
    "inventory": {
      "quantity": 34
    }
  },
  {
    "gtin": "01000038",
    "name": "Lime Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744973280/products/pim/5060420234107-1902181444/lansinoh-babyflasche-naturalwave-von-geburt-an-160ml",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.355
    },
    "placements": [
      {
        "shelfId": "UNNM",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62fe"
      }
    ],
    "inventory": {
      "quantity": 34
    }
  },
  {
    "gtin": "01000039",
    "name": "Mint Chutney",
    "brandName": "TropicalTaste",
    "baseCategory": "Condiments",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983535/products/pim/4008137009312-990918173/bad-heilbrunner-arzneitee-husten-und-bronchial-tee-12-beutel",
    "imageOutline": {
      "x0": 0.135,
      "y0": 0.0,
      "x1": 0.865,
      "y1": 1.0,
      "aspect": 0.73
    },
    "placements": [
      {
        "shelfId": "8PGQ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5b9f"
      }
    ],
    "inventory": {
      "quantity": 23
    }
  },
  {
    "gtin": "01000040",
    "name": "Orange Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744747073/products/pim/4058172623714-2300518/babylove-abendbrei-griess-pur-ab-dem-5-monat",
    "imageOutline": {
      "x0": 0.235,
      "y0": 0.0,
      "x1": 0.77,
      "y1": 1.0,
      "aspect": 0.535
    },
    "placements": [
      {
        "shelfId": "UNMG",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62cf"
      }
    ],
    "inventory": {
      "quantity": 3423
    }
  },
  {
    "gtin": "01000041",
    "name": "Papaya Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744995998/products/pim/4260401410778-89679819/paediprotect-baby-und-kinder-badezusatz-pflegebad",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.395
    },
    "placements": [
      {
        "shelfId": "27RF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f0d"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000042",
    "name": "Quince Jelly",
    "brandName": "BerryBest",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744829593/products/pim/4066447237542-4139974/balea-after-shave-pflege-gel-sensitive",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "9VTV",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5aa9"
      }
    ],
    "inventory": {
      "quantity": 342
    }
  },
  {
    "gtin": "01000043",
    "name": "Raisin Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1750986824/products/pim/9120082226899-2056715774/spirit-cherry-blossom-eau-de-parfum",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.84,
      "y1": 1.0,
      "aspect": 0.675
    },
    "placements": [
      {
        "shelfId": "IDJM",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ef5"
      }
    ],
    "inventory": {
      "quantity": 32
    }
  },
  {
    "gtin": "01000044",
    "name": "Spinach Wrap",
    "brandName": "HealthyChoice",
    "baseCategory": "Wraps & Tortillas",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748304678/products/pim/4067796203639-2146359630/dmbio-brotaufstrich-getrocknete-tomate-und-feta",
    "imageOutline": {
      "x0": 0.085,
      "y0": 0.0,
      "x1": 0.915,
      "y1": 1.0,
      "aspect": 0.83
    },
    "placements": [
      {
        "shelfId": "1ZTQ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff54a1"
      }
    ],
    "inventory": {
      "quantity": 65
    }
  },
  {
    "gtin": "01000045",
    "name": "Tapioca Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1753406707/products/pim/4058172812965-3558055/babylove-babywasser",
    "imageOutline": {
      "x0": 0.36,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.275
    },
    "placements": [
      {
        "shelfId": "LOQJ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5b3b"
      }
    ],
    "inventory": {
      "quantity": 66
    }
  },
  {
    "gtin": "01000046",
    "name": "Ugli Fruit Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744821202/products/pim/4023103238992-3935353/vileda-allzwecktuecher-mikrofaser-colors-multipack",
    "imageOutline": {
      "x0": 0.2,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.595
    },
    "placements": [
      {
        "shelfId": "54NS",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5be8"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000047",
    "name": "Vanilla Wafers",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.59,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744804061/products/pim/3600523350186-3408904/l-oreal-paris-anti-falten-nachtcreme-experte-55",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.2,
      "x1": 1.0,
      "y1": 0.8,
      "aspect": 1.6667
    },
    "placements": [
      {
        "shelfId": "SKVR",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5bf9"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  },
  {
    "gtin": "01000048",
    "name": "Watermelon Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745005822/products/pim/3574661842608-1286120853/neutrogena-bodylotion-deep-moisture-sensitiv",
    "imageOutline": {
      "x0": 0.34,
      "y0": 0.01,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.3384
    },
    "placements": [
      {
        "shelfId": "GOWC",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f32"
      }
    ],
    "inventory": {
      "quantity": 34
    }
  },
  {
    "gtin": "01000049",
    "name": "Xtra Crunch Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744803532/products/pim/4066447185287-3373996/babylove-betteinlagen",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.835,
      "y1": 1.0,
      "aspect": 0.67
    },
    "placements": [
      {
        "shelfId": "FW8T",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ed7"
      }
    ],
    "inventory": {
      "quantity": 66
    }
  },
  {
    "gtin": "01000050",
    "name": "Yam Fries",
    "brandName": "VeggieBake",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1753406707/products/pim/4058172812965-3558055/babylove-babywasser",
    "imageOutline": {
      "x0": 0.36,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.275
    },
    "placements": [
      {
        "shelfId": "QYLL",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ec2"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  },
  {
    "gtin": "01000051",
    "name": "Apple Cider",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744766526/products/pim/4058172934384-2917274/reell-e-ansatzspray-blond-bis-mittelblond",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "6TW1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5e8f"
      }
    ],
    "inventory": {
      "quantity": 10
    }
  },
  {
    "gtin": "01000052",
    "name": "Apple Pie",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747705041/products/pim/4062300419407-1031445645/hipp-babysanft-baby-waschgel-haut-und-haar-sensitiv-nachfuellpack",
    "imageOutline": {
      "x0": 0.17,
      "y0": 0.0,
      "x1": 0.835,
      "y1": 1.0,
      "aspect": 0.665
    },
    "placements": [
      {
        "shelfId": "2B3W",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5efd"
      }
    ],
    "inventory": {
      "quantity": 90
    }
  },
  {
    "gtin": "01000053",
    "name": "Banana Bread",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001584/products/pim/4062300463455-1786658256/hipp-babysnack-knusperstangen-mit-apfel-und-karotte-ab-dem-8-monat",
    "imageOutline": {
      "x0": 0.14,
      "y0": 0.0,
      "x1": 0.86,
      "y1": 1.0,
      "aspect": 0.72
    },
    "placements": [
      {
        "shelfId": "27RF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5eaf"
      }
    ],
    "inventory": {
      "quantity": 40
    }
  },
  {
    "gtin": "01000054",
    "name": "Banana Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980898/products/pim/4066447710083-413034/babylove-baby-kopf-bis-fuss-waschgel-nachfuellpack",
    "imageOutline": {
      "x0": 0.215,
      "y0": 0.005,
      "x1": 0.79,
      "y1": 1.0,
      "aspect": 0.5779
    },
    "placements": [
      {
        "shelfId": "QYLL",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff606e"
      }
    ],
    "inventory": {
      "quantity": 60
    }
  },
  {
    "gtin": "01000055",
    "name": "Carrot Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745006031/products/pim/3574661332574-585676595/neutrogena-anti-pickel-gesichtsmaske-2in1",
    "imageOutline": {
      "x0": 0.25,
      "y0": 0.0,
      "x1": 0.755,
      "y1": 1.0,
      "aspect": 0.505
    },
    "placements": [
      {
        "shelfId": "CD3W",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff61ad"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  },
  {
    "gtin": "01000056",
    "name": "Carrot Muffin",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002435/products/pim/5011321772335-1402007474/old-spice-after-shave-original",
    "imageOutline": {
      "x0": 0.29,
      "y0": 0.0,
      "x1": 0.71,
      "y1": 1.0,
      "aspect": 0.42
    },
    "placements": [
      {
        "shelfId": "TGBW",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff61bc"
      }
    ],
    "inventory": {
      "quantity": 40
    }
  },
  {
    "gtin": "01000057",
    "name": "Dairy Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1758158634/products/pim/4062300419391-1897205884/hipp-babysanft-baby-waschgel-haut-und-haar-sensitiv",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "XER4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff620a"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "9100000161723",
    "name": "Dairy Cheese",
    "brandName": "MilkyWay",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000414/products/pim/3600542415095-1923903499/garnier-skin-active-bb-creme-all-in-1-pflege-matt-hell-lsf-25",
    "imageOutline": {
      "x0": 0.245,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.505
    },
    "placements": [
      {
        "shelfId": "NHTB",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6259"
      }
    ]
  },
  {
    "gtin": "01000059",
    "name": "Egg Salad",
    "brandName": "HealthyChoice",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747307772/products/pim/4015637822990-1827635258/bauck-muehle-backmischung-brownies-glutenfrei",
    "imageOutline": {
      "x0": 0.17,
      "y0": 0.0,
      "x1": 0.83,
      "y1": 1.0,
      "aspect": 0.66
    },
    "placements": [
      {
        "shelfId": "UOKX",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff622a"
      }
    ]
  },
  {
    "gtin": "01000060",
    "name": "Egg Tart",
    "brandName": "SweetTreats",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001552/products/pim/8700216679381-1520439350/pampers-baby-pants-premium-protection-gr-6-xl-13-19kg-big-pack",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.055,
      "x1": 1.0,
      "y1": 0.945,
      "aspect": 1.1236
    },
    "placements": [
      {
        "shelfId": "UNMG",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62fa"
      }
    ]
  }
]